// Meal Type routes
export default [
  {
    path: '/meal-types',
    name: 'meal-types',
    component: () => import('@/views/admin/MealTypesView.vue'),
    meta: {
      title: 'Meal Types',
      requiresAuth: true
    }
  }
]
